<template lang="pug">
modal-window.modal-notification(:width='600', :height='400', :title='title', ref='modal')
  .modal-notification__inner(v-html='message')
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import ModalWindow from '@/components/molecules/student/ModalWindow.vue'
import { NotificationItem } from '@/models/notificationModel'

/**
 * お知らせモーダル
 */
@Component({
  components: {
    ModalWindow,
  },
})
export default class ModalNotification extends Vue {
  // お知らせ
  @Prop()
  notification?: NotificationItem

  @Ref() modal!: ModalWindow

  private get title() {
    return this.notification ? this.notification.title : ''
  }

  private get message() {
    return this.notification ? this.notification.message : ''
  }

  public show() {
    this.modal.show()
  }
}
</script>

<style lang="stylus" scoped>
.modal-notification
  &__inner
    padding 20px
</style>
